// extracted by mini-css-extract-plugin
module.exports = {"activeComponent":"styles_activeComponent__vAvUC","card":"styles_card__ItMjd"};